export const MUTATE_SHOW_FOOTER = 'MUTATE_SHOW_FOOTER';
export const MUTATE_SHOW_NAVIGATION = 'MUTATE_SHOW_NAVIGATION';
export const MUTATE_LOADER = 'MUTATE_LOADER';
export const MUTATE_TITLE = 'MUTATE_TITLE';
export const MUTATE_HEADER_STYLE = 'MUTATE_HEADER_STYLE';

interface IUIStore {
    showFooter: boolean;
    showNavigation: boolean;
    loading: boolean;
    getTitle: string;
    getHeaderStyle: boolean;
}

// initial state
const UIState: IUIStore = {
    showFooter: true,
    showNavigation: false,
    loading: false,
    getTitle: '',
    getHeaderStyle: false,
};

// getters
const getters = {
  getShowFooter: (state: IUIStore) => state.showFooter,
  getShowNavigation: (state: IUIStore) => state.showNavigation,
  getLoader: (state: IUIStore) => state.loading,
  getTitle: (state: IUIStore) => state.getTitle,
  getHeaderStyle: (state: IUIStore) => state.getHeaderStyle,
};

// mutations
const mutations = {
  [MUTATE_SHOW_FOOTER](state: IUIStore, payload: boolean) {
    state.showFooter = payload;
  },
  [MUTATE_SHOW_NAVIGATION](state: IUIStore, payload: boolean) {
    state.showNavigation = payload;
  },
  [MUTATE_LOADER](state: IUIStore, payload: boolean) {
    state.loading = payload;
  },
  [MUTATE_TITLE](state: IUIStore, payload: string) {
    state.getTitle = payload;
  },
  [MUTATE_HEADER_STYLE](state: IUIStore, payload: boolean) {
    state.getHeaderStyle = payload;
  },
};

// actions
const actions = {
};

export default {
    state: UIState,
    getters,
    actions,
    mutations,
};
